export const convertUtils = {
    buildMenuTree: (menuList) => {
        // 메뉴 맵 생성 (메뉴 번호로 빠르게 접근하기 위함)
        const menuMap = {};
        const rootMenus = [];
        
        // 1단계: 기본 정보로 맵 구성
        menuList.forEach(menu => {
            menuMap[menu.menu_id] = {
                ...menu,
                depth: 1,
                childCount: 0,
                children: []
            };
        });
        
        // 2단계: 부모-자식 관계 설정 및 깊이/자식 수 계산
        Object.values(menuMap).forEach(menu => {
            if (menu.parent_id && menuMap[menu.parent_id]) {
                const parent = menuMap[menu.parent_id];
                parent.children.push(menu);
                parent.childCount++;
                menu.depth = parent.depth + 1;
            } else {
                rootMenus.push(menu);
            }
        });

        // 3단계: sort_ord를 기준으로 정렬
        // 최상위 메뉴 정렬
        rootMenus.sort((a, b) => a.sort_ord - b.sort_ord);
        
        // 각 상위 메뉴의 하위 메뉴들도 정렬
        rootMenus.forEach(menu => {
            if (menu.children && menu.children.length > 0) {
                menu.children.sort((a, b) => a.sort_ord - b.sort_ord);
            }
        });
        
        return rootMenus;
    }
};
